import { render } from "./Section01.vue?vue&type=template&id=ef3d8a9a&scoped=true"
import script from "./Section01.vue?vue&type=script&lang=js"
export * from "./Section01.vue?vue&type=script&lang=js"

import "./Section01.vue?vue&type=style&index=0&id=ef3d8a9a&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef3d8a9a"]])

export default __exports__